import {ApiFunction, ChatbotApi} from "../chatbot/towersChatbotApi";

export class SquadDiskUsersApi {
    static async getUserInfoByUid({uid}) {
        const fn = new ApiFunction('getUserInfoByUid', ChatbotApi.baseUrl);
        return fn.call({uid});
    }

    static async findUserDetails({userName, code}) {
        const fn = new ApiFunction('findUserDetails', ChatbotApi.baseUrl);
        return fn.call({userName, code});
    }

    // Obtener todos los usuarios
    static async getAllUsers() {
        const fn = new ApiFunction('getAllUsers', ChatbotApi.baseUrl);
        return fn.call({});
    }

    // Actualizar permisos de un usuario
    static async updateUserPermissions(userId, permissions) {
        const fn = new ApiFunction('updateUserPermissions', ChatbotApi.baseUrl);
        return fn.call({userId, permissions});
    }

    // Eliminar usuario
    static async deleteUser(userId) {
        const fn = new ApiFunction('deleteUser', ChatbotApi.baseUrl);
        return fn.call({userId});
    }

    static async updateUserPreference({key, value}) {
        const fn = new ApiFunction('updateUserPreference', ChatbotApi.baseUrl);
        return fn.call({key, value});
    }

    static async getUserPreferences() {
        const fn = new ApiFunction('getUserPreferences', ChatbotApi.baseUrl);
        return fn.call({});
    }

    static async getUserRights(userUid) {
        const getUserRights = new ApiFunction('getUserPermissions', ChatbotApi.baseUrl);
        return getUserRights.call({userId: userUid});
    }
}
